import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

import Card from "@material-ui/core/Card";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import Divider from "@material-ui/core/Divider";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import { selectClaims } from "../claims/claimsSlice";
import { selectCustomisation } from "../customisation/customisationSlice";
import MemberOrders from "../orders/MemberOrders";
import { selectOrders } from "../orders/ordersSlice";
import {purchasePoints, selectUserPoints, setCreateStatus, ColorButton} from "../userPoints/userPointsSlice";
import MemberDetails from "./MemberDetails";
import MemberPasswordReset from "./MemberPasswordReset";
import MemberPoints from "./MemberPoints";
import { fetchUserByID, selectUsers, fetchMyself } from "./usersSlice";
import {fetchPrograms, selectPrograms} from "../programs/programsSlice";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";


const useStyles = makeStyles((theme) => ({
  tabBar: {
    // backgroundColor: ' rgba(0, 0, 0, 0.08)',
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    // alignItems: 'center',
    borderRadius: "10px",
    backgroundColor: "#fff",
    padding: 0,
    height: "100%",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    padding: theme.spacing(1, 3, 2),
    color: theme.palette.secondaryFont.main,
  },
  linkText: {
    fontSize: 16,
    display: "flex",
    alignItems: "center",
  },
  headerContainer: {
    margin: theme.spacing(2),
  },
  subHeader: { margin: theme.spacing(2), marginBottom: 0 },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  tabContent: {
    display: "flex",
    flexFlow: "column nowrap",
    flexGrow: 1,
  },
  root: {
    display: "flex",
  },
  indicator: {
    backgroundColor: theme.palette.primary.main,
  },
  title: {
    color: "#fff",
    padding: 16,
    backgroundColor: theme.palette.secondary.main,
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
  },
  historyCardEdit: {
    flexGrow: 1,
  },
  formControl: {
    // borderWidth: 2,
    borderStyle: "solid",
    // borderColor: theme.palette.primaryFont.main,
    borderRadius: 16,
    display: "flex",
    marginTop: 12,
    marginBottom: 24,
  },
  textLabel: {
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: 8,
    marginTop: 8,
  },
  textInput: {},
  userDetailsContainer: {
    padding: 24,
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "space-between",
  },
}));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

/** utility function to convert dollars to cents to avoid floating point math
 */
function toCents(value) {
  if (value == null) return null;
  const v = String(value).trim();
  if (v === "") return null;

  // remove spaces/commas (1,234.56 -> 1234.56)
  const normalized = v.replace(/[,\s]/g, "");

  // validate number format (optional minus; we’ll forbid negative later)
  const m = /^-?\d+(?:\.\d+)?$/.exec(normalized);
  if (!m) return null;

  const neg = normalized.startsWith("-");
  const [intPartRaw, decPartRaw = ""] = normalized.replace("-", "").split(".");

  const intPart = intPartRaw === "" ? "0" : intPartRaw;
  const decPart = (decPartRaw + "00").slice(0, 2); // pad/truncate to 2

  // integer math only
  const cents =
      Number(intPart) * 100 +
      Number(decPart);

  return neg ? -cents : cents;
}

function TabPanel({ value, index, children, ...props }) {
  const classes = useStyles();
  const isActive = value === index;
  return (
      <div
          role="tabpanel"
          hidden={!isActive}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...props}
      >
        {isActive && <div className={classes.tabContent}>{children}</div>}
      </div>
  );
}



export default function UserContainer(props) {
  // const {userAccount, error, loading} = props;

  const classes = useStyles();

  const { error, loading, users, user, signedIn, userAccount } =
    useSelector(selectUsers);
  const { customisation } = useSelector(selectCustomisation);

  const { claimsList } = useSelector(selectClaims);
  const { ordersList } = useSelector(selectOrders);
  const { pointsHistory } = useSelector(selectUserPoints);
  const location = useLocation();
  let jwtToken = localStorage.getItem("clientToken");

  const dispatch = useDispatch();

  // store the clicked tab value in state
  const [tab, setTab] = useState('profile');


  useEffect(() => {
    if (!user.id) {
      let userID = location.pathname.split("/")[3];
      dispatch(
        fetchUserByID({
          id: userID,
          token: jwtToken,
        })
      );
    }
  }, []);
  
  useEffect(() => {
    dispatch(fetchMyself({
      token: jwtToken,
    }))
  }, [])

  /* Points Purchase Popup */
  const { createStatus, memberPoint } = useSelector(selectUserPoints);
  const { programsList } = useSelector(selectPrograms);
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [programID, setProgramID] = useState("");
  const [notes, setNotes] = useState("");

  // store the state of whether the points purchase popup is open
  const [popupOpen, setPopupOpen] = useState(false);

  const handlePointsPurchasePopup = (event) => {
    event.preventDefault(); // stops the normal tab switch

    setPaymentAmount(0);
    setProgramID("");
    setNotes("");
    dispatch(setCreateStatus(false));
    setPopupOpen(true);
  };

  const handlePopupClose = () => {
    setPaymentAmount(0);
    setProgramID("");
    setNotes("");

    setPopupOpen(false);
    // setEdit(false);
    dispatch(setCreateStatus(false));
  };


  useEffect(() => {
    dispatch(
        fetchPrograms({
          token: jwtToken,
          query: `?limit=200&statuses=1`,
        })
    );
  }, []);

  useEffect(() => {
    if (createStatus) {
      handlePopupClose();
    }
  }, [createStatus]);

  const handlePointsPurchaseSubmit = (event) => {
    event.preventDefault();
    const jwtToken = localStorage.getItem("clientToken");

    const cents = toCents(paymentAmount);

// block negatives / zero
    if (cents == null || cents <= 0) {
      // show validation error to the user
    }

    const paymentDetails = {
      amount_cents: cents,
      orderID: "",
      notes: notes,
    };

    if (programID) {
      paymentDetails.programID = programID;
    }

    dispatch(
        purchasePoints({
          token: jwtToken,
          userID: user.id,
          paymentDetails: paymentDetails,
        })
    );
  };

  const handleTabsChange = (e, v) => {
    if (v === "points_purchase") {
      // Don’t switch tab
      handlePointsPurchasePopup(e);
      return;
    }
    setTab(v);
  };

  return (
    <Container className={classes.paper} component="main" maxWidth="lg">
      {/* // <Container className={classes.paper} fixed> */}
      {loading === "loaded" && user && (
        <Card style={{ height: "100%" }} elevation={4}>
          <AppBar className={classes.tabBar} position="static">
            <Tabs
              classes={{
                indicator: classes.indicator,
              }}
              value={tab}
              onChange={handleTabsChange}
              aria-label="Member Account Tabs"
            >
              <Tab label="Member Details" value="profile" />
              <Tab label="Points History" value="points" />
              {/* <Tab label="Claims History" {...a11yProps(2)} /> */}
              <Tab label="Orders History" value="orders" />
              {userAccount.roleID === 1 && [
                    <Tab label="Reset Password" value="password_reset" />,
                    <Tab label="Points Purchase" value="points_purchase" />,
                  ]}
            </Tabs>
          </AppBar>

          <TabPanel value={tab} index="profile">
            <MemberDetails userAccount={userAccount} user={user} />
            <Divider />
          </TabPanel>

          <TabPanel value={tab} index="points">
            <MemberPoints pointsList={pointsHistory} userAccount={userAccount} user={user} />
          </TabPanel>

          <TabPanel value={tab} index="orders">
            <MemberOrders ordersList={ordersList} userAccount={userAccount} user={user} />
          </TabPanel>

          {userAccount.roleID === 1 && (
              <TabPanel value={tab} index="password_reset">
                <MemberPasswordReset userAccount={userAccount} user={user} />
              </TabPanel>
          )}


          { /* DEPRECATED
          <Grid
            container
            role="tabpanel"
            hidden={value !== 0}
            id={`simple-tabpanel-${0}`}
            aria-labelledby={`simple-tab-${0}`}
          >
            {value === 0 && (
              <div className={classes.tabContent}>
                <MemberDetails userAccount={userAccount} user={user} />

                <Divider />
              </div>
            )}
          </Grid>
          <Grid
            container
            role="tabpanel"
            hidden={value !== 1}
            id={`simple-tabpanel-${1}`}
            aria-labelledby={`simple-tab-${1}`}
          >
            {value === 1 && (
              <div className={classes.tabContent}>
                <MemberPoints
                  pointsList={pointsHistory}
                  userAccount={userAccount}
                  user={user}
                />
              </div>
            )}
          </Grid>
          */ }

          {/* <Grid
            container
            role="tabpanel"
            hidden={value !== 2}
            id={`simple-tabpanel-${2}`}
            aria-labelledby={`simple-tab-${2}`}
          >
            {value === 2 && (
              <div className={classes.tabContent}>
                <MemberClaims claimsList={claimsList} userAccount={userAccount} user={user} />
              </div>
            )}
          </Grid> */}

          { /* DEPRECATED
          <Grid
              container
              role="tabpanel"
              hidden={value !== 2}
              id={`simple-tabpanel-${2}`}
              aria-labelledby={`simple-tab-${2}`}
          >
            {value === 2 && (
                <div className={classes.tabContent}>
                  <MemberOrders
                      ordersList={ordersList}
                      userAccount={userAccount}
                      user={user}
                  />
                </div>
            )}
          </Grid>
          */ }
          {userAccount.roleID === 1 && (
              <>
                {/*
                <Grid
                    container
                    role="tabpanel"
                    hidden={value !== 3}
                    id={`simple-tabpanel-${3}`}
                    aria-labelledby={`simple-tab-${3}`}
                >
                  {value === 3 && (
                      <div className={classes.tabContent}>
                        <MemberPasswordReset userAccount={userAccount} user={user} />
                      </div>
                  )}
                </Grid>
                <Grid
                    container
                    role="tabpanel"
                    hidden={value !== 4}
                    id={`simple-tabpanel-${4}`}
                    aria-labelledby={`simple-tab-${4}`}
                >
                  {value === 4 && (
                      <div className={classes.tabContent}>
                        <MemberPasswordReset userAccount={userAccount} user={user} />
                      </div>
                  )}
                </Grid>
                */ }
                {/* Points Purchase Popup */}
                <Dialog
                    open={popupOpen}
                    onClose={handlePopupClose}
                    aria-labelledby="form-dialog-title"
                    fullWidth={true}
                    maxWidth="sm"
                >
                  <DialogTitle
                      disableTypography
                      className={classes.title}
                      id="form-dialog-title"
                  >
                    {"Member Points Purchase"}
                  </DialogTitle>
                  <form className={classes.form} onSubmit={handlePointsPurchaseSubmit}>
                    <DialogContent style={{ padding: 24 }}>
                      <Grid className={classes.historyCardEdit}>
                        <div className={classes.textLabel}>Payment Amount: </div>
                        <TextField
                            id="standard-number"
                            label=""
                            type="number"
                            variant="outlined"
                            min="0"
                            className={classes.textInputField}
                            value={paymentAmount}
                            fullWidth
                            required
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              startAdornment: <InputAdornment position="start">$</InputAdornment>,
                            }}
                            onChange={(e) => setPaymentAmount(e.target.value)}
                        />
                        <div className={classes.textLabel}>Program: </div>
                        <FormControl variant="outlined" className={classes.formControl}>
                          <Select
                              labelId="programID-simple-select-outlined-label"
                              id="programID-simple-select-outlined"
                              value={programID}
                              onChange={(e) => setProgramID(e.target.value)}
                              InputLabelProps={{ shrink: false }}
                          >
                            {programsList.map((program) => (
                                <MenuItem
                                    className={classes.colorItem}
                                    key={program.id}
                                    value={program.id}
                                >
                                  {program.name}
                                </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <div className={classes.textLabel}>Notes: </div>
                        <TextField
                            className={classes.textInputField}
                            fullWidth
                            required
                            id="outlined-multiline-static"
                            label=""
                            multiline
                            variant="outlined"
                            rows={4}
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                        />
                      </Grid>
                    </DialogContent>
                    <Divider />
                    <DialogActions
                        style={{ paddingLeft: 24, paddingRight: 24, paddingBottom: 16 }}
                    >
                      <Grid container spacing={2} direction="row">
                        <Grid item sm>
                          <ColorButton onClick={handlePopupClose} color="primary">
                            Cancel
                          </ColorButton>
                        </Grid>
                        <Grid item sm>
                          <ColorButton type="submit" color="secondary">
                            Create Payment
                          </ColorButton>
                        </Grid>
                      </Grid>
                    </DialogActions>
                  </form>
                </Dialog>
              </>
          )}
        </Card>
      )}
    </Container>
  );
}
